import { render, staticRenderFns } from "./AboutTeamSection.vue?vue&type=template&id=dbaddace&scoped=true&"
var script = {}
import style0 from "./AboutTeamSection.vue?vue&type=style&index=0&id=dbaddace&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbaddace",
  null
  
)

export default component.exports